<template>

    <div>
        <div class="flex items-center gap-4 px-6 py-[11px] h-[60px] border-b border-t border-gray-200">
            <select v-model="filters_data.calendar_view" class="w-1/2 h-full rounded border text-sm block appearance-none bg-white hover:bg-gray-100 hover:cursor-pointer border-gray-300 text-gray-700 py-2 px-5 leading-tight focus:outline-none focus:outline-0 focus:bg-white focus:border-gray-500 dark:bg-gray-900/80 dark:hover:bg-zinc-900/60 dark:border-gray-500 dark:text-gray-400">
                <option v-for="option in useCalendarStoreObj().views_list" :value="option.key">
                    {{ option.value }}
                </option>
            </select>
            <button @click="goToToday" class="w-1/2 text-gray-700 bg-white hover:bg-gray-100 font-medium rounded text-sm px-5 py-[7px] text-center border border-gray-300 dark:bg-gray-900/80 dark:hover:bg-zinc-900/60 dark:border-gray-500 dark:text-gray-400">{{ I18N.website.homepage.frontsection.today}}</button>
            <a href="/calendar/settings" class="absolute left-[250px] rounded-full w-10 h-10 hover:bg-gray-100 flex justify-center items-center">
                <svg class="w-6 h-6 fill-gray-500" viewBox="0 0 24 24" ><path d="M13.85 22.25h-3.7c-.74 0-1.36-.54-1.45-1.27l-.27-1.89c-.27-.14-.53-.29-.79-.46l-1.8.72c-.7.26-1.47-.03-1.81-.65L2.2 15.53c-.35-.66-.2-1.44.36-1.88l1.53-1.19c-.01-.15-.02-.3-.02-.46 0-.15.01-.31.02-.46l-1.52-1.19c-.59-.45-.74-1.26-.37-1.88l1.85-3.19c.34-.62 1.11-.9 1.79-.63l1.81.73c.26-.17.52-.32.78-.46l.27-1.91c.09-.7.71-1.25 1.44-1.25h3.7c.74 0 1.36.54 1.45 1.27l.27 1.89c.27.14.53.29.79.46l1.8-.72c.71-.26 1.48.03 1.82.65l1.84 3.18c.36.66.2 1.44-.36 1.88l-1.52 1.19c.01.15.02.3.02.46s-.01.31-.02.46l1.52 1.19c.56.45.72 1.23.37 1.86l-1.86 3.22c-.34.62-1.11.9-1.8.63l-1.8-.72c-.26.17-.52.32-.78.46l-.27 1.91c-.1.68-.72 1.22-1.46 1.22zm-3.23-2h2.76l.37-2.55.53-.22c.44-.18.88-.44 1.34-.78l.45-.34 2.38.96 1.38-2.4-2.03-1.58.07-.56c.03-.26.06-.51.06-.78s-.03-.53-.06-.78l-.07-.56 2.03-1.58-1.39-2.4-2.39.96-.45-.35c-.42-.32-.87-.58-1.33-.77l-.52-.22-.37-2.55h-2.76l-.37 2.55-.53.21c-.44.19-.88.44-1.34.79l-.45.33-2.38-.95-1.39 2.39 2.03 1.58-.07.56a7 7 0 0 0-.06.79c0 .26.02.53.06.78l.07.56-2.03 1.58 1.38 2.4 2.39-.96.45.35c.43.33.86.58 1.33.77l.53.22.38 2.55z"></path><circle cx="12" cy="12" r="3.5"></circle></svg>
            </a>
        </div>  
        <div class="px-2">
            <v-date-picker  class="mycalendar" 
                            :key="datePickerKey"
                            :locale="CURRENT_LOCALE"
                            v-model="filters_data.selected_date"
                            :is-dark="isDark"
                            @update:from-page="calendarPageChange"
                            title-position="left" />
        </div>  
        <div>
            <p class="font-semibold pl-3 mb-2 dark:text-gray-400">{{ APPLICATION_NAME }} {{ I18N.application.index.events }}</p>
            <div class="px-2 mb-2">
                <TimelydoDropdown
                  title=" "
                  name="event"
                  :selected_value="useCalendarStoreObj().selected_event"
                  :values="useCalendarStoreObj().events"
                  :opts="{ search_able: true, sort_able: false, maximum_height: '160px'}"
                  @change="updateSelectedEvent"
                >
                </TimelydoDropdown>
            </div>
        </div>  
        <div v-if="anyConnectedCalendars" ref="listSection" class="dark:text-gray-400">
            <div class="flex items-center justify-between mb-4">
                <p class="font-semibold pl-3">{{ I18N.website.homepage.features.home_features.connected_calendar }}</p>
                <a href="/connected_calendars?connect=true"
                   data-tooltip-target="tooltip-connect"
                   data-tooltip-placement="top"
                   class="text-2xl w-8 h-8 rounded-full hover:bg-gray-100 hover:text-gray-900 flex items-center justify-center text-gray-700 dark:text-gray-400 font-medium">
                   +
                </a>
                <div id="tooltip-connect" role="tooltip" class="absolute z-10 invisible inline-block px-2 py-1 text-xs font-medium text-white transition-opacity duration-300 bg-gray-700 rounded shadow-sm opacity-0 tooltip ">
                   {{ I18N.features.bookings.connect_new_calendar }}
                </div>
            </div>
            <label v-for="calendar in filters_data.calendars_list" :key="calendar.id" class="w-full hover:bg-gray-100 hover:cursor-pointer text-sm text-gray-700 items-center flex px-3 py-2 group dark:text-gray-400 dark:hover:bg-gray-600">
                <input type="checkbox" @change="callFilterChange()" v-model="calendar.active" :style="{color: calendar.color_code, 'border-color': calendar.color_code}"  class="w-[20px] h-[20px] border-[2.3px] rounded-[2px] border-important focus:ring-transparent focus:ring-0 focus:outline-0 focus:outline-none mr-2">
                <span class="truncate">{{ calendar.calendarId }}</span>
                <button
                  type="button"
                  class="hidden w-7 group-hover:inline-flex focus:inline-flex text-gray-400 bg-transparent hover:bg-gray-50 hover:text-gray-900 rounded-full text-sm justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                  data-tooltip-target="tooltip-options" data-tooltip-placement="top"
                  data-dropdown-placement="bottom"
                  v-bind:data-dropdown-toggle="'calendar-color-dropdown-' + calendar.id"
                >
                    <svg class="fill-gray-500 w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path></svg>
                </button>
                <div v-bind:id="'calendar-color-dropdown-' + calendar.id" class="hidden z-20 bg-white border border-gray-200 shadow divide-y divide-gray-100 rounded w-[168px] dark:bg-gray-700 dark:text-gray-200 dark:border-gray-500">
                    <div class="border-b px-4 py-2 ">
                        <p> {{ I18N.features.bookings.choose_a_color }} </p>
                    </div>
                    <ul class="flex flex-wrap p-3">
                        <li class="mx-1 mb-2">
                            <input @change="handleChangeColor(calendar)" v-model="calendar.color" type="radio" id="tomato-selected" name="color" value="tomato" class="hidden peer" required>
                            <label for="tomato-selected" class="flex cursor-pointer">   
                              <div data-tooltip-target="tooltip-tomato" data-tooltip-placement="top" class="w-5 h-5 rounded-full tomato flex items-center justify-center">
                                 <svg class="hidden fill-white w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ><path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path></svg>
                              </div>
                               <div id="tooltip-tomato" role="tooltip" class="absolute z-10 invisible inline-block px-2 py-1 text-xs font-medium text-white transition-opacity duration-300 bg-gray-700 rounded shadow-sm opacity-0 tooltip" >
                                   {{ I18N.application.holidays.tomato }}
                               </div>
                            </label>
                        </li>
                        <li class="mx-1 mb-2">
                            <input @change="handleChangeColor(calendar)" v-model="calendar.color" type="radio" id="flamingo-selected" name="color" value="flamingo" class="hidden peer">
                            <label for="flamingo-selected" class="flex  cursor-pointer">
                                    <div data-tooltip-target="tooltip-flamingo" data-tooltip-placement="top" class="w-5 h-5 rounded-full flamingo flex items-center justify-center">
                                        <svg class="hidden fill-white w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ><path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path></svg>
                                    </div>
                                    <div id="tooltip-flamingo" role="tooltip" class="absolute z-10 invisible inline-block px-2 py-1 text-xs font-medium text-white transition-opacity duration-300 bg-gray-700 rounded shadow-sm opacity-0 tooltip 0">
                                        {{ I18N.application.holidays.flamingo }}
                                    </div>
                            </label>
                        </li>
                        <li class="mx-1 mb-2">
                            <input @change="handleChangeColor(calendar)" v-model="calendar.color" type="radio" id="tangerine-selected" name="color" value="tangerine" class="hidden peer">
                            <label for="tangerine-selected" class="flex  cursor-pointer">
                                    <div data-tooltip-target="tooltip-tangerine" data-tooltip-placement="top" class="w-5 h-5 rounded-full tangerine flex items-center justify-center">
                                        <svg class="hidden fill-white w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ><path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path></svg>
                                    </div>
                                    <div id="tooltip-tangerine" role="tooltip" class="absolute z-10 invisible inline-block px-2 py-1 text-xs font-medium text-white transition-opacity duration-300 bg-gray-700 rounded shadow-sm opacity-0 tooltip ">
                                        {{ I18N.application.holidays.tangerine }}
                                    </div>
                            </label>
                        </li>
                        <li class="mx-1 mb-2">
                            <input @change="handleChangeColor(calendar)" v-model="calendar.color" type="radio" id="banana-selected" name="color" value="banana" class="hidden peer">
                            <label for="banana-selected" class="flex cursor-pointer">
                                    <div data-tooltip-target="tooltip-banana" data-tooltip-placement="top" class="w-5 h-5 rounded-full banana flex items-center justify-center">
                                       <svg class="hidden fill-white w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ><path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path></svg>
                                    </div>
                                    <div id="tooltip-banana" role="tooltip" class="absolute z-10 invisible inline-block px-2 py-1 text-xs font-medium text-white transition-opacity duration-300 bg-gray-700 rounded shadow-sm opacity-0 tooltip 0">
                                        {{ I18N.application.holidays.banana }}
                                    </div>
                            </label>
                        </li>
                        <li class="mx-1 mb-2">
                            <input @change="handleChangeColor(calendar)" v-model="calendar.color" type="radio" id="peacock-selected" name="color" value="peacock" class="hidden peer">
                            <label for="peacock-selected" class="flex cursor-pointer">
                                    <div data-tooltip-target="tooltip-peacock" data-tooltip-placement="top" class="w-5 h-5 rounded-full peacock flex items-center justify-center">
                                        <svg class="hidden fill-white w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ><path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path></svg>
                                    </div>
                                    <div id="tooltip-peacock" role="tooltip" class="absolute z-10 invisible inline-block px-2 py-1 text-xs font-medium text-white transition-opacity duration-300 bg-gray-700 rounded shadow-sm opacity-0 tooltip 0">
                                        {{ I18N.application.holidays.peacock }}
                                    </div>
                            </label>
                        </li>
                        <li class="mx-1">
                            <input @change="handleChangeColor(calendar)" v-model="calendar.color" type="radio" id="sage-selected" name="color" value="sage" class="hidden peer">
                            <label for="sage-selected" class="flex cursor-pointer">
                                    <div data-tooltip-target="tooltip-sage" data-tooltip-placement="top" class="w-5 h-5 rounded-full sage flex items-center justify-center">
                                        <svg class="hidden fill-white w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ><path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path></svg>
                                    </div>
                                    <div id="tooltip-sage" role="tooltip" class="absolute z-10 invisible inline-block px-2 py-1 text-xs font-medium text-white transition-opacity duration-300 bg-gray-700 rounded shadow-sm opacity-0 tooltip 0">
                                        {{ I18N.application.holidays.sage }}
                                    </div>
                            </label>
                        </li>
                        <li class="mx-1 mb-2">
                            <input @change="handleChangeColor(calendar)" v-model="calendar.color" type="radio" id="basil-selected" name="color" value="basil" class="hidden peer">
                            <label for="basil-selected" class="flex  cursor-pointer">
                                    <div data-tooltip-target="tooltip-basil" data-tooltip-placement="top" class="w-5 h-5 rounded-full basil flex items-center justify-center">
                                        <svg class="hidden fill-white w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ><path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path></svg>
                                    </div>
                                    <div id="tooltip-basil" role="tooltip" class="absolute z-10 invisible inline-block px-2 py-1 text-xs font-medium text-white transition-opacity duration-300 bg-gray-700 rounded shadow-sm opacity-0 tooltip 0 ">
                                        {{ I18N.application.holidays.basil }}
                                    </div>
                            </label>
                        </li>
                        <li class="mx-1 mb-2">
                            <input @change="handleChangeColor(calendar)" v-model="calendar.color" type="radio" id="blueberry-selected" name="color" value="blueberry" class="hidden peer">
                            <label for="blueberry-selected" class="flex  cursor-pointer">
                                    <div data-tooltip-target="tooltip-blueberry" data-tooltip-placement="top" class="w-5 h-5 rounded-full blueberry flex items-center justify-center">
                                        <svg class="hidden peer-checked:block fill-white w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ><path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path></svg>
                                    </div>
                                    <div id="tooltip-blueberry" role="tooltip" class="absolute z-10 invisible inline-block px-2 py-1 text-xs font-medium text-white transition-opacity duration-300 bg-gray-700 rounded shadow-sm opacity-0 tooltip ">
                                        {{ I18N.application.holidays.blueberry }}
                                    </div>
                            </label>
                        </li>
                        <li class="mx-1 mb-2">
                            <input @change="handleChangeColor(calendar)" v-model="calendar.color" type="radio" id="lavender-selected" name="color" value="lavender" class="hidden peer">
                            <label for="lavender-selected" class="flex cursor-pointer">
                                    <div data-tooltip-target="tooltip-lavender" data-tooltip-placement="top" class="w-5 h-5 rounded-full lavender flex items-center justify-center">
                                        <svg class="hidden fill-white w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ><path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path></svg>
                                    </div>
                                    <div id="tooltip-lavender" role="tooltip" class="absolute z-10 invisible inline-block px-2 py-1 text-xs font-medium text-white transition-opacity duration-300 bg-gray-700 rounded shadow-sm opacity-0 tooltip  ">
                                        {{ I18N.application.holidays.lavender }}
                                    </div>
                            </label>
                        </li>
                        <li class="mx-1 mb-2">
                            <input @change="handleChangeColor(calendar)" v-model="calendar.color" type="radio" id="grape-selected" name="color" value="grape" class="hidden peer">
                            <label for="grape-selected" class="flex cursor-pointer">
                                    <div data-tooltip-target="tooltip-grape" data-tooltip-placement="top" class="w-5 h-5 rounded-full grape flex items-center justify-center">
                                        <svg class="hidden fill-white w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ><path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path></svg>
                                    </div>
                                    <div id="tooltip-grape" role="tooltip" class="absolute z-10 invisible inline-block px-2 py-1 text-xs font-medium text-white transition-opacity duration-300 bg-gray-700 rounded shadow-sm opacity-0 tooltip ">
                                        {{ I18N.application.holidays.grape }}
                                    </div>
                            </label>
                        </li>
                        <li class="mx-1 mb-2">
                            <input @change="handleChangeColor(calendar)" v-model="calendar.color" type="radio" id="graphite-selected" name="color" value="graphite" class="hidden peer">
                            <label for="graphite-selected" class="flex cursor-pointer">
                                    <div data-tooltip-target="tooltip-graphite" data-tooltip-placement="top" class="w-5 h-5 rounded-full graphite flex items-center justify-center">
                                        <svg class="hidden fill-white w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ><path d="m10 15.586-3.293-3.293-1.414 1.414L10 18.414l9.707-9.707-1.414-1.414z"></path></svg>
                                    </div>
                                    <div id="tooltip-graphite" role="tooltip" class="absolute z-10 invisible inline-block px-2 py-1 text-xs font-medium text-white transition-opacity duration-300 bg-gray-700 rounded shadow-sm opacity-0 tooltip ">
                                        {{ I18N.application.holidays.graphite }}
                                    </div>
                            </label>
                        </li>
                    </ul>
                </div>
            </label>
            <div id="tooltip-options" role="tooltip" class="absolute z-10 invisible inline-block px-2 py-1 text-xs font-medium text-white transition-opacity duration-300 bg-gray-700 rounded shadow-sm opacity-0 tooltip ">
              {{ I18N.features.bookings.options }}
            </div>
        </div>  
        <div v-else>
            <div class="border flex flex-col border-blue-600 rounded mx-2 my-2 px-2 pb-4 pt-2 bg-blue-400/10">
                <div class="flex items-center">
                    <div class="flex items-center justify-center p-1 rounded-full border-blue-600/20 border">
                        <div class="flex items-center justify-center p-[3px] rounded-full border-blue-600/60 border">
                            <svg class="w-4 h-4 fill-blue-600" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"></path><path d="M11 11h2v6h-2zm0-4h2v2h-2z"></path></svg>
                        </div>
                    </div>
                    <h4 class="text-blue-700 font-medium text-[15px] ml-0.5 whitespace-nowrap">{{ I18N.features.bookings.no_calendar_connected }}</h4>
                </div>
                <p class="text-sm text-blue-600 mt-1.5 mb-3">{{ I18N.features.bookings.no_calendar_connected_subheading }}</p>
                <a class="border border-blue-600 bg-blue-500/20 w-full text-center text-blue-700 rounded px-3 py-1.5" href="/connected_calendars?connect=true">{{ I18N.website_content.connected_calendar.connect_calendar }}</a>
            </div>
        </div>
    </div>
  
</template>

<script>
import RequestMixin from "controllers/vue_components/mixins/request"
import Constants from "controllers/vue_components/mixins/constants"
import TimelydoDropdown from "controllers/vue_components/fields/timelydo_dropdown"
import { useCalendarStore } from 'controllers/vue_components/calendar/store'

export default {
    name: 'CalendarFilters',
    mixins: [RequestMixin, Constants],
    props: ['host', 'calendars_list_json'],
    components: {
        TimelydoDropdown
    },
    data() {
        return {
            isDark: document.documentElement.classList.contains('dark'),
            parsed_host: {
                calendar_view: 'week',
            },
            filters_data: {
                bookings_start_at: null,
                bookings_end_at: null,
                selected_date: new Date(),
                calendars_list: [],
                calendar_view: 'week',
                color_changed: false,
                current_calendar_month: {
                    month: (new Date().getMonth() + 1),
                    year: new Date().getFullYear(),
                }
            },
            datePickerKey: 0,
        };
    },
    
    methods: {
        useCalendarStoreObj() {
            return useCalendarStore();
        },
        async handleChangeColor(calendar) {
            let response = await this.axiosRequest('PUT',`/api/v1/connected_calendars/${calendar.id}`, {connected_calendar: calendar}, false)
            if (response.js_error == false && response.response.success) {
                Object.assign(calendar, response.response.data);
                this.$refs.listSection.click();
                this.filters_data.color_changed = true;
            }
        },
        getFirstDateOfLastMonth(today) {
            let lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);

            return lastMonth;
        },

        getLastDateOfNextMonth(today) {
            var nextMonth = new Date(today.getFullYear(), today.getMonth() + 2, 0);

            return nextMonth;
        },

        callHomeToFetchData() {
            this.callFilterChange()
        },

        callFilterChange() {
            this.$emit('filterChanged', this.filters_data);
        },

        receiveDataFromHome(data_set) {
            this.filters_data.color_changed = false;
            // this.calendars_list = data_set.calendars_list
            // this.filters_data.calendars_list = this.calendars_list
        },

        calendarPageChange(event) {
           this.filters_data.current_calendar_month = event;
            const currentSelectedDate = this.filters_data.selected_date;
            const currentMonth = currentSelectedDate ? currentSelectedDate.getMonth() + 1 : null;
            const currentYear = currentSelectedDate ? currentSelectedDate.getFullYear() : null;

            if (this.filters_data.calendar_view === 'month') {
                if (event.month !== currentMonth || event.year !== currentYear) {
                    const firstDayOfSelectedMonth = new Date(event.year, event.month - 1, 1);
                    this.filters_data.selected_date = firstDayOfSelectedMonth;
                }
            }
        },

        goToToday() {
            const today = new Date();
            this.filters_data.selected_date = today;
            this.calendarPageChange({
                month: today.getMonth() + 1,
                year: today.getFullYear(),
            });
            this.datePickerKey += 1;
        },
        updateSelectedEvent(e){
            this.useCalendarStoreObj().selected_event = e.event
        }
    },
    computed: {
        anyConnectedCalendars() {
            if (this.filters_data.calendars_list.length == 0) {
                return false
            } else {
                return true
            }
        },
    },
    created() {
        this.filters_data.calendars_list = JSON.parse(this.calendars_list_json)
        this.filters_data.bookings_start_at = this.getFirstDateOfLastMonth(new Date())
        this.filters_data.bookings_end_at = this.getLastDateOfNextMonth(new Date())
        this.parsed_host = JSON.parse(this.host)
        this.filters_data.calendar_view = this.parsed_host.calendar_view
        this.callHomeToFetchData();
    },

    watch: {
        'filters_data.current_calendar_month'(newValue, oldValue) {
            if(newValue.month !== oldValue.month) {
              let firstDayofThisMonth = new Date(newValue.year, newValue.month - 1, 1);
              this.filters_data.bookings_start_at = this.getFirstDateOfLastMonth(firstDayofThisMonth)
              this.filters_data.bookings_end_at = this.getLastDateOfNextMonth(firstDayofThisMonth)
              this.callFilterChange()
            }
        },
        'filters_data.selected_date'(newValue, oldValue) {
            this.callFilterChange()
        },
        'filters_data.color_changed'(newValue, oldValue) {
            this.callFilterChange()
        },

    }
};
</script>
